import { render, staticRenderFns } from "./ProgrammeSignup.vue?vue&type=template&id=063a3949&scoped=true&"
import script from "./ProgrammeSignup.vue?vue&type=script&lang=js&"
export * from "./ProgrammeSignup.vue?vue&type=script&lang=js&"
import style0 from "./ProgrammeSignup.vue?vue&type=style&index=0&id=063a3949&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063a3949",
  null
  
)

export default component.exports